import libphonenumber from 'google-libphonenumber'

const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance()
const allowType = [
  // 市話部分阻擋，留手機
  // libphonenumber.PhoneNumberType.FIXED_LINE,
  libphonenumber.PhoneNumberType.MOBILE,
  libphonenumber.PhoneNumberType.FIXED_LINE_OR_MOBILE,
]

const { countryCodeToRegionCodeMap } = libphonenumber.metadata
const regionCodeToCountryCodeMap = Object.keys(countryCodeToRegionCodeMap).reduce((result, key) => {
  countryCodeToRegionCodeMap[key].forEach((regionCode) => {
    result[regionCode] = key
  })
  return result
}, {})

function isValid(phone) {
  try {
    const number = phoneUtil.parseAndKeepRawInput(phone)
    return phoneUtil.isValidNumber(number) && allowType.includes(phoneUtil.getNumberType(number))
  } catch (e) {
    return false
  }
}

function getNationalNumber(phone) {
  const number = phoneUtil.parseAndKeepRawInput(`+${phone}`)
  return number.getNationalNumber()
}

function getCountryCode(region) {
  return regionCodeToCountryCodeMap[region]
}

function extractCountryCode(phone) {
  if (!phone || !phone.startsWith('+')) return null
  try {
    const number = phoneUtil.parseAndKeepRawInput(phone)
    if (number) {
      const countryCode = number.getCountryCode().toString()
      let nationalNumber = number.getNationalNumber().toString()
      if (number.getItalianLeadingZero()) {
        nationalNumber = '0' + nationalNumber
      }
      return { countryCode, nationalNumber }
    }
  } catch (e) {
    // ignore
  }
  return null
}

function cleanPhone(phone, countryCode) {
  if (!phone) return phone

  const attemptParse = (phoneStr) => {
    try {
      const numberToParse = phoneStr.startsWith('+') ? phoneStr : `+${countryCode}${phoneStr}`
      const number = phoneUtil.parseAndKeepRawInput(numberToParse)
      if (phoneUtil.isValidNumber(number)) {
        let nationalNumber = number.getNationalNumber().toString()
        if (number.getItalianLeadingZero()) {
          nationalNumber = '0' + nationalNumber
        }

        // 修正 NANP 等含有區碼被當成 countryCode 的情況 (例如關島 +1671)
        const realCountryCode = number.getCountryCode().toString()
        if (countryCode && countryCode !== realCountryCode && countryCode.startsWith(realCountryCode)) {
          const prefix = countryCode.slice(realCountryCode.length)
          if (nationalNumber.startsWith(prefix)) {
            nationalNumber = nationalNumber.slice(prefix.length)
          }
        }
        return nationalNumber
      }
    } catch (e) {
      // ignore
    }
    return null
  }

  const validResult = attemptParse(phone)
  if (validResult) return validResult

  // 嘗試移除多餘的 leading zero (使用者可能誤植)
  let strippedPhone = phone
  while (strippedPhone.startsWith('0')) {
    strippedPhone = strippedPhone.slice(1)
    if (!strippedPhone) break
    const strippedResult = attemptParse(strippedPhone)
    if (strippedResult) return strippedResult
  }

  return phone
}

export default { isValid, getNationalNumber, getCountryCode, extractCountryCode, cleanPhone }
